import BaseAction from "../base_action";
import { EXPORT_LIBRARY_CONTROLS_TO_EXCEL } from '../../constants'

export default class LibraryControlAction extends BaseAction {

  exportControlsToExcel = (options) => {
    const action = EXPORT_LIBRARY_CONTROLS_TO_EXCEL;
    const url = '/__api/v1/library_controls/excel';
    return this.apiGet(action, url, { params: options, responseType: 'blob' });
  }

}


// WEBPACK FOOTER //
// ./src/actions/v2/library_control.js